export default __webpack_public_path__ + "static/media/ZAM.549076e6.svg";